export const formatCurrency = (value) => {
  if (value == null) return "--";
  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (abs >= 1e9) return `${sign}$${(abs / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${sign}$${(abs / 1e3).toFixed(0)}K`;
  return `${sign}$${abs.toFixed(0)}`;
};

export const formatPercent = (value) => {
  if (value == null) return "--";
  return `${value >= 0 ? "" : ""}${value.toFixed(1)}%`;
};

export const formatNumber = (value) => {
  if (value == null) return "--";
  return new Intl.NumberFormat("en-US").format(value);
};

export const formatMultiple = (value) => {
  if (value == null) return "--";
  return `${value.toFixed(2)}x`;
};

export const getChangeClass = (value) => {
  if (value > 0) return "positive";
  if (value < 0) return "negative";
  return "";
};
